import { Calendar } from "@/components/ui/calendar"
import { cn } from "@/lib/utils"
import { useEffect, useMemo, useState } from "react"


export const CalendarWithTime = ({
    dateKey,
    dateValue,
    onDateChange,
    timeValue,
    onTimeChange,
    markedDatesMap,
    markedTimesMap,
    onMarkedTimeSelected,
    blockedTimes,
    hideMarkedLabel
}) => {
    const [loadingSlots, setLoadingSlots] = useState(false)
    const [slots, setSlots] = useState([])

    const todayKey = new Date().toISOString().slice(0, 10)

    const isFutureOrToday = dateKey && dateKey >= todayKey
    const daySlots = isFutureOrToday ? slots : []

    useEffect(() => {
        if (!dateKey) return

        const fetchSlots = async () => {
            setLoadingSlots(true)
            try {
                const res = await fetch(process.env.REACT_APP_BACKEND_URL + `/api/booking/slots?date=${dateKey}`)
                if (!res.ok) throw new Error("Ошибка загрузки слотов")
                const data = await res.json()
                setSlots(data.slots)
            } catch (err) {
                toast.error(err.message || "Ошибка сервера")
            } finally {
                setLoadingSlots(false)
            }
        }

        fetchSlots()
    }, [dateKey, markedDatesMap])

    const buttonStyle = (t, available) => cn(
        "px-3 py-2 flex gap-2 rounded-md max-w-[200px] items-center justify-start text-sm border transition-colors",
        !available && !markedTimesMap?.some(mt => mt.time === t) || blockedTimes?.some(bt => bt === t) ? "opacity-40 cursor-not-allowed" : "",
        markedTimesMap?.some(mt => mt.time === t) ? "border-emerald-200 text-emerald-900/80" : "",
        timeValue === t ? "bg-olive-800 text-olive-50 border-olive-800" : "hover:bg-olive-600",
    )

    return (

        <div className="rounded-2xl bg-white/5 backdrop-blur-sm p-4 border border-olive-100 flex gap-2 justify-center sm:justify-start">
            <Calendar
                fromDate={new Date()}
                mode="single"
                selected={dateValue}
                onSelect={onDateChange}
                className="rounded-md border-0 mx-0 px-0"
                markedDatesMap={markedDatesMap}
            />
            <div className="flex flex-col gap-2 items-center sm:items-start justify-start mt-4 max-h-[290px] overflow-y-auto flex-1 scroll-hide">
                {!dateKey && <p className="col-span-3 text-center text-sm mt-4 text-olive-900/60">Выберите дату для выбора времени</p>}
                {dateKey && !isFutureOrToday && <p className="col-span-3 mt-4 text-center text-sm text-olive-900/60">Выберите другую дату</p>}
                {loadingSlots && <p className="col-span-3 text-sm text-center mt-4 text-olive-900/60">Загрузка...</p>}
                {daySlots.map(({ time: t, available }) => (
                    <button
                        key={t}
                        type="button"
                        disabled={!available && !markedTimesMap?.some(mt => mt.time === t) || blockedTimes?.some(bt => bt === t)}
                        onClick={() => {
                            if (markedTimesMap?.some(mt => mt.time === t)) {
                                onMarkedTimeSelected && onMarkedTimeSelected(markedTimesMap.find(mt => mt.time === t))
                            } else {
                                onMarkedTimeSelected && onMarkedTimeSelected(null)
                            }
                            onTimeChange(t)
                        }}
                        className={buttonStyle(t, available)}
                    >
                        {t} {markedTimesMap?.some(mt => mt.time === t) && !hideMarkedLabel ? <span> - {markedTimesMap?.find(mt => mt.time === t).name}</span> : null}
                    </button>
                ))}
            </div>
        </div>
    )
}